import {
  QuestionBase,
  QuestionModalProps,
} from '@/components/decision-tree/components/SurveyItem/components/Question/types';
import { AnswerModel } from '@/components/decision-tree/hooks';

export type DateValidation = {
  min: string;
  max: string;
  type: 'date';
};

export interface DateQuestion extends QuestionBase {
  placeholder: string;
  type: 'date';
  validationValues?: DateValidation;
}

export type DateAnswer = {
  type: 'date';
  value: string;
};

export type DateProps = QuestionModalProps & {
  data: DateQuestion;
  defaultValue?: DateAnswer;
  saveAnswer: (payload: AnswerModel) => void;
};

export const uiDateFormat = 'MM/dd/yyyy';
export const isoDateFormat = 'yyyy-MM-dd';
